import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';
export const SubText = (props) => {
    const styles = StyleSheet.create({
        text: {
            fontSize: 15,
            letterSpacing: 0.15,
        },
    });
    return (_jsx(Text, { numberOfLines: props.numberOfLines, ellipsizeMode: props.ellipsizeMode, style: [styles.text, props.style], onPress: props.onPress, children: props.children }));
};
